module.exports = __webpack_public_path__ + "media/img/img-misson-dev-66f6d8bb.png";